import styled from 'styled-components';

export const ChatFooterContainer = styled.div`
  padding: 12px 10px 12px 14px;
  border-radius: 0 0 12px 12px;
  gap: 8px;
  border-top: 1px solid #f0f0f0;
  overscroll-behavior: none;
`;

export const ChatInput = styled.textarea`
  flex: 1;
  border: none;
  height: 108px;
  width: 100%;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #000000;
  padding: 12px 16px;
  resize: none;
  overflow-y: auto;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 8px;
  scroll-snap-type: none;
  overscroll-behavior: none;

  @media (max-width: 768px) {
    height: 108px;
  }

  &:focus {
    border: 2px solid #3d72fa;
  }

  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
  }
`;

export const ChatFooterButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SendButton = styled.button`
  background: #333333;
  color: #ffffff;
  width: 111px;
  height: 40px;
  padding: 14px 24px;

  display: flex;
  justify-content: center;
  align-items: center;

  border: none;
  font-family: Lato;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 3.87px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;

  @media (hover: hover) {
    &:hover {
      background-color: #757575;
    }
  }

  &:disabled {
    background-color: #f0f0f0;
    color: #bdbdbd;
    cursor: not-allowed;

    svg path {
      fill: #bdbdbd;
    }
  }
`;

export const ResetButton = styled.button`
  background: #ffffff;
  color: #000000;
  width: 91px;
  height: 40px;
  gap: 6px;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: Lato;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 3.87px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;

  @media (hover: hover) {
    &:hover {
      border: none;
      color: #757575;

      svg path {
        fill: #757575;
      }
    }
  }

  &:disabled {
    border: none;
    color: #bdbdbd;
    cursor: not-allowed;

    svg path {
      fill: #bdbdbd;
    }
  }
`;
